import * as React from 'react';
import dynamic from 'next/dynamic';
import { GetStaticPaths, GetStaticProps } from 'next';
import { useHydrateAtoms } from 'jotai/utils';

import { getServerTranslations } from '../../get-server-side-translations';
import { initialMapViewStateAtom } from '../../components/ask-for-referral/ask-for-referral.atoms';

const AskForReferralContent = dynamic(() => import('../../components/ask-for-referral/ask-for-referral-content'), {
  ssr: false,
});

const DEFAULT_VIEW_STATE = { latitude: 41.9028, longitude: 12.4964, zoom: 5.5 };

const CITY_CONFIGS: Record<string, { latitude: number; longitude: number; zoom: number }> = {
  torino: { latitude: 45.070312, longitude: 7.686856, zoom: 10 },
  roma: { latitude: 41.902782, longitude: 12.496366, zoom: 10 },
  milano: { latitude: 45.458656, longitude: 9.180887, zoom: 10 },
};

type CityPageProps = {
  initialViewState: { latitude: number; longitude: number; zoom: number };
};

const AskForReferralCityPage: React.FunctionComponent<CityPageProps> = ({ initialViewState }) => {
  useHydrateAtoms([[initialMapViewStateAtom, initialViewState]]);

  return <AskForReferralContent />;
};

export default AskForReferralCityPage;

export const getStaticPaths: GetStaticPaths = async () => {
  const cities = Object.keys(CITY_CONFIGS);
  return {
    paths: cities.map((city) => ({ params: { city } })),
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps<CityPageProps> = async ({ locale, params }) => {
  const city = params?.city as string;
  const config = CITY_CONFIGS[city] || DEFAULT_VIEW_STATE;

  const transConfig = await getServerTranslations(locale, ['common', 'ask-for-referral', 'restaurant-onboarding']);

  return {
    props: {
      initialViewState: config,
      ...transConfig,
    },
  };
};
